module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_trash_48x48_hover_UBPE.17a91ad7.svg";